export function initXpProductsFilter() {
	const inputs = [...document.querySelectorAll('#xp-products-filter-items input[name="catalog_xp"]')];
	if (!inputs.length) return;

	const all = inputs.find(i => i.value === 'all');

	const apply = () => {
		const selected = inputs.filter(i => i.checked && i !== all).map(i => i.value);

		document.querySelectorAll('.catalog__xp-group--products .product-card').forEach(card => {
			const cats = (card.dataset.xpCategory || '').split(' ');
			const show = !selected.length || selected.some(v => cats.includes(v));
			card.style.display = show ? '' : 'none';
		});
	};

	inputs.forEach(input => {
		input.addEventListener('change', () => {
			if (input === all) {
				inputs.forEach(i => (i.checked = i === all));
			} else if (input.checked && all) {
				all.checked = false;
			}

			if (all && !inputs.some(i => i.checked)) all.checked = true;

			inputs.forEach(i => i.closest('.filter__item')?.classList.toggle('is-active-filter', i.checked));
			apply();
		});
	});
}
